<template>
  <div class="console-box">
    <!-- 个人实时概览 -->
    <div class="console-item">
      <div>
        <div class="console-title">个人实时概览</div>
        <div class="console-text">监控系统活动及服务运行状况</div>
      </div>
      <!-- <div class="report-time-box">
        <div class="report-box report-export" @click="onExport">
          <img class="report-img" src="@/assets/image/report-img.png" alt="" />
          <div class="report-text">导出报表</div>
        </div>
      </div> -->
    </div>

    <div class="console-list-box">
      <div class="console-list">
        <div class="total-box">
          <div class="total-icon total-icon-blue">
            <img class="keFu" src="@/assets/image/conversation.png" />
          </div>
          <div class="total-text total-text-blue">
            <template v-if="customerInfo.sessionTrend >= 0">
              <img class="icon-img" src="../assets/image/gp-s.png" alt="" />
              <div>+{{ customerInfo.sessionTrend }}%</div>
            </template>
            <template v-else>
              <img class="icon-img" src="../assets/image/gp-x.png" alt="" />
              <div style="color: red">{{ customerInfo.sessionTrend }}%</div>
            </template>
          </div>
        </div>
        <div class="total-label">今日会话总量</div>
        <div class="total-value">{{ customerInfo.todaySessionCount }}</div>
      </div>
      <div class="console-list">
        <div class="total-box">
          <div class="total-icon total-icon-yellow">
            <img class="keFu" src="@/assets/image/responseTime.png" />
          </div>
          <div class="total-text total-text-yellow">
            <!-- 上升 -->
            <template v-if="customerInfo.responseTimeTrend >= 0">
              <img class="icon-img" src="../assets/image/gp-s.png" alt="" />
              <div>+{{ customerInfo.responseTimeTrend }}秒</div>
            </template>
            <!-- 下降 -->
            <template v-else>
              <img class="icon-img" src="../assets/image/gp-x.png" alt="" />
              <div style="color: red">{{ customerInfo.responseTimeTrend }}秒</div>
            </template>
          </div>
        </div>
        <div class="total-label">平均响应时间</div>
        <div class="total-value">{{ customerInfo.avgResponseTime }}</div>
      </div>
      <div class="console-list">
        <div class="total-box">
          <div class="total-icon total-icon-green">
            <img class="keFu" src="@/assets/image/satisfaction.png" />
          </div>
          <div class="total-text total-text-green">
            <img class="achieve" v-if="customerInfo.satisfactionScore >= 90" src="@/assets/image/achieve.png" />
            <div class="totalText" v-if="customerInfo.satisfactionScore >= 90">达标</div>
            <div class="totalText" style="color: red" v-else>未达标</div>
          </div>
        </div>
        <div class="total-label">客户满意度</div>
        <div class="total-value">{{ customerInfo.satisfactionScore }}%</div>
      </div>
      <div class="console-list">
        <div class="total-box">
          <div class="total-icon total-icon-purple">
            <img class="keFu" src="@/assets/image/keFu.png" />
          </div>
          <div class="total-text total-text-purple">
            <!-- <span class="iconfont icon-kongzhitai" style="font-size: 12px"></span> -->
            实时
          </div>
        </div>
        <div class="total-label">当前在线坐席</div>
        <div class="total-value">{{ customerInfo.onlineCustomerCount }} / {{ customerInfo.totalCustomerCount }}</div>
      </div>
    </div>

    <!-- 会话量趋势 -->
    <div class="trend">
      <div class="trend-box">
        <div>
          <div class="trend-title">会话量趋势</div>
          <div class="trend-text">实时每小时会话波动情况</div>
        </div>
        <div class="trend-time-box">
          <div class="trend-time" :class="{ 'is-active': activeTrend === 'today' }" @click="handleTrendChange('today')">
            <div class="trend-line" :style="getTrendLineStyle('today')"></div>
            <div class="trend-today">今日</div>
          </div>
          <!-- <div class="trend-time trendTime" :class="{ 'is-active': activeTrend === 'yesterday' }" @click="handleTrendChange('yesterday')">
            <div class="trend-line" :style="getTrendLineStyle('yesterday')"></div>
            <div class="trend-today">昨日</div>
          </div> -->
        </div>
      </div>
      <div ref="sessionTrendChart" class="trend-chart"></div>
    </div>

    <div class="source-box">
      <!-- 会话来源 -->
      <div class="source-item">
        <div class="source-title">会话来源</div>
        <div class="source-text">不同平台的流量分布</div>
        <div v-for="(item, index) in sourceData" :key="index" style="display: contents">
          <div class="application-box">
            <div class="application-title">{{ item.name }}</div>
            <div class="application-number">{{ item.percent }}%</div>
          </div>
          <div class="progress-bar progressBar">
            <div class="progress-fill" :style="{ width: item.percent + '%', background: item.color }"></div>
          </div>
        </div>
      </div>
      <!-- 表现优异坐席 -->
      <div class="source-list">
        <div class="seating-box">
          <div class="seating-label">
            <div class="seating-title">表现优异坐席</div>
            <div class="seating-desc">根据满意度及处理效率排名</div>
          </div>
          <div class="seating-btn" @click="openAgentModal">查看全部</div>
        </div>
        <div class="seating-item">
          <div class="seating-lable">坐席</div>
          <div class="seating-lable">处理会话</div>
          <div class="seating-lable">平均耗时</div>
          <div class="seating-lable">满意度评分</div>
        </div>
        <el-scrollbar class="agent-scrollbar">
          <div v-if="agentList && agentList.length" class="agent-list">
            <div class="list-item" v-for="agent in agentList" :key="agent.id">
              <div class="list-img-box">
                <div class="list-img-circle">
                  <head-image :url="agent.headImage" :size="32" radius="6px" :name="agent.nickName"></head-image>
                  <!-- <img class="list-image" :src="agent.headImage" /> -->
                  <div>
                    <div class="list-name">{{ agent.nickName }}</div>
                  </div>
                </div>
                <div class="list-num">{{ agent.todaySessionCount }}</div>
                <div class="list-time">{{ agent.avgResponseTime }}ms</div>
                <div class="list-score">
                  <div class="list-score-text">{{ agent.satisfactionScore }}%</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="agent-empty">
            <el-empty description="暂无坐席数据"></el-empty>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <el-dialog title="表现优异坐席" :visible.sync="agentModalVisible" width="900px" append-to-body :close-on-click-modal="false">
      <div class="agent-search-box">
        <el-input
          v-model="agentQuery.userName"
          placeholder="请输入坐席名称"
          clearable
          size="small"
          class="agent-search-input"
          @keyup.enter.native="handleAgentSearch"
          @clear="handleAgentSearch"
        />

        <el-button type="primary" size="small" @click="handleAgentSearch"> 搜索 </el-button>

        <el-button size="small" @click="handleAgentReset"> 重置 </el-button>
      </div>
      <el-table class="agent-table" :data="agentTableList" border style="width: 100%">
        <!-- 头像列 -->
        <el-table-column label="头像" align="center" width="80">
          <template slot-scope="scope">
            <head-image :url="scope.row.headImage" :size="44" :name="scope.row.nickName" :isShowUserInfo="false" radius="6px"></head-image>
            <!-- <img class="agent-table-avatar" :src="scope.row.headImage" /> -->
          </template>
        </el-table-column>

        <!-- 名字列 -->
        <el-table-column label="坐席" align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.nickName || ''" placement="top">
              <span class="agent-table-name">
                {{ scope.row.nickName }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="todaySessionCount" label="处理会话" align="center" />

        <el-table-column label="平均耗时" align="center">
          <template slot-scope="scope"> {{ scope.row.avgResponseTime }}ms </template>
        </el-table-column>

        <el-table-column label="满意度评分" align="center">
          <template slot-scope="scope"> {{ scope.row.satisfactionScore }}% </template>
        </el-table-column>
      </el-table>

      <div class="agent-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="agentQuery.pageNum"
          :page-size="agentQuery.pageSize"
          :page-sizes="[5, 10, 20]"
          :total="agentTotal"
          @size-change="handleAgentSizeChange"
          @current-change="handleAgentCurrentChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import HeadImage from "../components/common/HeadImage.vue";

export default {
  name: "console",
  components: {
    HeadImage
  },
  data() {
    return {
      activeTrend: "today",
      trendChart: null,
      trendTimes: [],
      trendCounts: [],
      sourceMap: {
        0: { name: "移动应用", color: "#2563EB" },
        1: { name: "网页", color: "#10B981" },
        2: { name: "其他渠道", color: "#9CA3AF" },
        3: { name: "社交媒体", color: "#F59E0B" }
      },
      sourceData: [],
      // 新增坐席列表数据
      agentList: [],
      customerInfo: {},
      //
      agentModalVisible: false, //
      agentTableList: [],
      agentTotal: 0,
      agentQuery: {
        pageNum: 1,
        pageSize: 5,
        userName: ""
      }
    };
  },
  methods: {
    handleTrendChange(type) {
      this.activeTrend = type;
      this.renderTrendChart();
    },
    getTrendLineStyle(type) {
      const activeColor = "#0052D9";
      const defaultColor = "#E5E7EB";
      return {
        background: this.activeTrend === type ? activeColor : defaultColor
      };
    },
    initTrendChart() {
      if (!this.$refs.sessionTrendChart) {
        return;
      }

      if (!this.trendChart) {
        this.trendChart = echarts.init(this.$refs.sessionTrendChart);
      }

      this.renderTrendChart();
    },
    renderTrendChart() {
      if (!this.trendChart) {
        return;
      }

      const xData = this.trendTimes || [];
      const yData = (this.trendCounts || []).map((item) => Number(item || 0));
      const hasData = xData.length > 0;

      this.trendChart.setOption({
        color: ["#165DFF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 0,
          textStyle: {
            color: "#FFFFFF"
          },
          formatter: (params) => {
            const point = params && params[0] ? params[0] : {};
            return `${point.axisValue || ""}<br/>会话量：${point.data || 0}`;
          }
        },
        grid: {
          top: 20,
          right: 20,
          bottom: 30,
          left: 40
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData,
          axisLine: {
            lineStyle: {
              color: "#E5E7EB"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#9CA3AF",
            fontSize: 12
          }
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          splitLine: {
            lineStyle: {
              color: "#F3F4F6"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#9CA3AF",
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "line",
            smooth: true,
            symbol: hasData ? "circle" : "none",
            symbolSize: 8,
            data: yData,
            lineStyle: {
              width: 4,
              color: "#165DFF"
            },
            itemStyle: {
              color: "#165DFF",
              borderColor: "#FFFFFF",
              borderWidth: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(22, 93, 255, 0.22)" },
                { offset: 1, color: "rgba(22, 93, 255, 0.02)" }
              ])
            }
          }
        ],
        legend: {
          top: 0,
          right: 0,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#4B5563",
            fontSize: 12
          },
          data: ["今日"]
        },
        graphic: !hasData
          ? [
              {
                type: "text",
                left: "center",
                top: "middle",
                style: {
                  text: "暂无趋势数据",
                  fill: "#9CA3AF",
                  fontSize: 14
                }
              }
            ]
          : []
      });
    },
    handleTrendResize() {
      if (this.trendChart) {
        this.trendChart.resize();
      }
    },
    onExport() {
      alert("导出");
    },
    // 获取详情
    getInfo() {
      this.$http({
        url: "/customer/info",
        method: "POST"
      }).then((res) => {
        this.customerInfo = res;
        this.agentList = res.customerExcellent;
        this.sourceData = (res.visitorSource || []).map((item) => {
          const config = this.sourceMap[item.visitorSource] || {
            name: "未知来源",
            color: "#999999"
          };

          return {
            ...item,
            name: config.name,
            color: config.color,
            percent: Number(item.percent || 0)
          };
        });

        this.trendTimes = res.sessionTrendTime || [];
        this.trendCounts = res.sessionTrendCount || [];

        this.$nextTick(() => {
          this.initTrendChart();
        });
      });
    },
    openAgentModal() {
      this.agentModalVisible = true;
      this.agentQuery.pageNum = 1;
      this.agentQuery.userName = "";
      this.loadList();
    },

    handleAgentSizeChange(size) {
      this.agentQuery.pageSize = size;
      this.agentQuery.pageNum = 1;
      this.loadList();
    },

    handleAgentCurrentChange(page) {
      this.agentQuery.pageNum = page;
      this.loadList();
    },
    handleAgentSearch() {
      if (this.agentQuery.userName.trim() == "") {
        this.$message.error("请输入坐席名称");
        return;
      }
      this.agentQuery.pageNum = 1;
      this.loadList();
    },

    handleAgentReset() {
      this.agentQuery.userName = "";
      this.agentQuery.pageNum = 1;
      this.loadList();
    },

    loadList() {
      this.$http({
        url: "/customer/rank",
        method: "POST",
        data: {
          pageSize: this.agentQuery.pageSize,
          pageNum: this.agentQuery.pageNum,
          nickName: this.agentQuery.userName
        }
      }).then((res) => {
        this.agentTableList = res.rows || [];
        this.agentTotal = res.total || 0;
      });
    }
  },
  mounted() {
    this.getInfo();
    this.$nextTick(() => {
      this.initTrendChart();
    });
    window.addEventListener("resize", this.handleTrendResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleTrendResize);

    if (this.trendChart) {
      this.trendChart.dispose();
      this.trendChart = null;
    }
  }
};
</script>

<style scoped lang="scss">
.console-box {
  width: 100%;
  height: calc(100vh - 65px);
  overflow: auto;
  background: linear-gradient(0deg, #f2f3f5 0%, #f2f3f5 100%), #fff;

  .console-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px;

    .console-title {
      font-size: 24px;
      color: #191b23;
      margin-bottom: 5px;
      text-align: left;
    }

    .console-text {
      font-size: 14px;
      color: #434654;
    }

    .report-time-box {
      display: flex;
      align-items: center;

      .report-box {
        font-size: 14px;
        padding: 8px 16px;
        border-radius: 2px;
        display: flex;
        align-items: center;
      }

      .report-time {
        color: #191b23;
        background: #ffffff;
        border: 1px solid #c3c6d7;
      }

      .report-export {
        color: #ffffff;
        background: #003da6;
        margin-left: 15px;
      }

      .report-img {
        width: 20px;
        height: 20px;
      }

      .report-text {
        margin-left: 5px;
      }
    }
  }

  .achieve {
    width: 12px;
    height: 12px;
  }

  .console-list-box {
    display: grid;
    gap: 20px;
    padding: 0 30px 30px 30px;
    grid-template-columns: repeat(4, 1fr);

    .keFu {
      width: 20px;
      height: 20px;
    }

    .console-list {
      padding: 25px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #c3c6d7;

      .total-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .total-icon-blue {
          color: #2563eb;
          background: #eff6ff;
        }

        .total-icon-yellow {
          color: #d97706;
          background: #fffbeb;
        }

        .total-icon-green {
          color: #059669;
          background: #ecfdf5;
        }

        .total-icon-purple {
          color: #9333ea;
          background: #faf5ff;
        }

        .total-text-yellow,
        .total-text-blue,
        .total-text-green {
          color: #006c46;
        }
        .icon-img {
          width: 12px;
        }
        .total-text-purple {
          color: #2563eb;
        }

        .total-icon {
          width: 36px;
          height: 36px;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .total-text {
          font-size: 12px;
          font-weight: 400;
          display: flex;
          align-items: center;

          .totalText {
            margin-bottom: 2px;
            margin-left: 2px;
          }
        }
      }

      .total-label {
        font-size: 12px;
        color: #434654;
        font-weight: 400;
        margin: 10px 0;
        text-align: left;
      }

      .total-value {
        font-size: 28px;
        color: #191b23;
        font-weight: 400;
        text-align: left;
      }
    }
  }

  .trend {
    padding: 25px;
    border-radius: 5px;
    background: #fff;
    margin: 0 30px 30px 30px;
    border: 1px solid #c3c6d7;

    .trend-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .trend-title {
        font-size: 20px;
        color: #191b23;
        font-weight: 400;
        text-align: left;
      }

      .trend-text {
        font-size: 14px;
        color: #434654;
        font-weight: 400;
      }

      .trend-time-box {
        display: flex;
        align-items: center;

        .trendTime {
          margin-left: 20px;
        }

        .trend-time {
          display: flex;
          align-items: center;
          cursor: pointer;

          .trend-line {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #e5e7eb;
            transition: background 0.3s;
          }

          .trend-today {
            color: #4b5563;
            margin-left: 8px;
            font-size: 12px;
          }
        }
      }
    }

    .trend-chart {
      width: 100%;
      height: 300px;
    }
  }

  .source-box {
    padding: 0 30px 30px 30px;
    display: flex;
    justify-content: space-between;

    .source-item {
      width: 30%;
      padding: 25px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #c3c6d7;

      .source-title {
        color: #191b23;
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 5px;
        text-align: left;
      }

      .source-text {
        color: #434654;
        font-size: 14px;
        margin-bottom: 30px;
        text-align: left;
      }

      .application-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .application-title {
          color: #374151;
          font-size: 14px;
          font-weight: 400;
        }

        .application-number {
          color: #111827;
          font-size: 14px;
          font-weight: 400;
        }
      }

      .progress-bar {
        width: 100%;
        height: 10px;
        border-radius: 20px;
        background: #f3f4f6;
        overflow: hidden;
      }

      .progressBar {
        margin-bottom: 30px;
      }

      .progress-fill {
        height: 100%;
        border-radius: 20px;
        transition: width 0.3s ease;
      }
    }

    .source-list {
      display: flex;
      flex-direction: column;
      width: 70%;
      padding: 25px 0;
      margin-left: 20px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #c3c6d7;

      .seating-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        padding: 0 25px;

        .seating-label {
          .seating-title {
            color: #191b23;
            font-size: 20px;
            font-weight: 400;
            margin-bottom: 5px;
            text-align: left;
          }

          .seating-desc {
            color: #434654;
            font-size: 14px;
            font-weight: 400;
          }
        }

        .seating-btn {
          color: #003da6;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          &:hover {
            color: #2764e6;
          }
        }
      }

      .seating-item {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f9fafb;
        border: 1px solid #f3f4f6;
        padding: 12px 25px;

        .seating-lable {
          width: 100%;
          color: #434654;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
        }
      }

      .agent-scrollbar {
        flex: 1;
        min-height: 0;
      }

      .agent-list {
        padding-bottom: 8px;
      }

      .agent-empty {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100%;
      }

      ::v-deep .agent-scrollbar .el-scrollbar__view {
        min-height: 100%;
      }

      ::v-deep .agent-scrollbar .el-scrollbar__wrap {
        height: 100%;
        overflow-x: hidden;
      }

      .list-item {
        padding: 18px 25px;
        height: 74px;
        box-sizing: border-box;
        border-bottom: 1px solid #f3f4f6;

        &:last-child {
          border-bottom: none;
        }

        .list-img-box {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .list-img-circle {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .list-image {
              width: 32px;
              height: 32px;
              border-radius: 6px;
              margin-right: 10px;
            }

            .list-name {
              color: #111827;
              font-size: 16px;
              font-weight: 400;
            }

            .list-title {
              color: #6b7280;
              font-size: 12px;
              font-weight: 400;
              text-align: left;
            }
          }

          .list-num {
            width: 100%;
            color: #191b23;
            font-size: 16px;
            text-align: center;
          }

          .list-time {
            width: 100%;
            color: #191b23;
            font-size: 16px;
            text-align: center;
          }

          .list-score {
            width: 100%;
            justify-items: center;

            .list-score-text {
              width: 55px;
              height: 25px;
              color: #047857;
              font-size: 12px;
              text-align: center;
              line-height: 25px;
              border-radius: 3px;
              background-color: #ecfdf5;
            }
          }
        }
      }
    }
  }
}
.agent-table {
  ::v-deep .el-table__header-wrapper {
    th {
      height: 48px;
      padding: 0;
      background: #f9fafb;
      color: #434654;
      font-size: 13px;
      font-weight: 400;
    }
  }

  ::v-deep .el-table__body-wrapper {
    .el-table__row {
      height: 70px;
    }

    td {
      padding: 10px 0;
      color: #191b23;
      font-size: 14px;
      vertical-align: middle;
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 50px;
      line-height: normal;
    }
  }
}
.agent-search-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 16px;

  .agent-search-input {
    width: 220px;
    margin-right: 10px;
  }

  .el-button + .el-button {
    margin-left: 10px;
  }
}
.agent-table-user {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.agent-table-avatar {
  width: 48px;
  height: 48px;
  max-width: 48px;
  max-height: 48px;
  margin-right: 10px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
}
.agent-table-name {
  max-width: 120px; // 控制长度，自己调
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agent-table-name {
  max-width: 120px;
  color: #111827;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-table-score {
  min-width: 55px;
  height: 25px;
  padding: 0 8px;
  color: #047857;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
  border-radius: 3px;
  background-color: #ecfdf5;
}

.agent-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
